export const cartQueryCustomFragment = `
    fragment CartFragment on Cart {
        id
        checkoutUrl
        totalQuantity
        buyerIdentity {
            countryCode
            customer {
                id
                email
                firstName
                lastName
                displayName
            }
            email
            phone
        }
        lines(first: $numCartLines) {
            edges {
                node {
                    id
                    quantity
                    attributes {
                        key
                        value
                    }
                    cost {
                        totalAmount {
                            amount
                            currencyCode
                        }
                        compareAtAmountPerQuantity {
                            amount
                            currencyCode
                        }
                    }
                    merchandise {
                        ... on ProductVariant {
                            id
                            availableForSale
                            compareAtPrice {
                                ...MoneyFragment
                            }
                            price {
                                ...MoneyFragment
                            }
                            requiresShipping
                            title
                            image {
                                ...ImageFragment
                            }
                            product {
                                handle
                                title
                                id
                            }
                            selectedOptions {
                                name
                                value
                            }
                        }
                    }
                    sellingPlanAllocation {
                        sellingPlan {
                            id
                            options {
                                name
                                value
                            }
                        }
                    }
                }
            }
        }
        cost {
            subtotalAmount {
                ...MoneyFragment
            }
            totalAmount {
                ...MoneyFragment
            }
            totalDutyAmount {
                ...MoneyFragment
            }
            totalTaxAmount {
                ...MoneyFragment
            }
        }
        note
        attributes {
            key
            value
        }
        discountCodes {
            code
            applicable
        }
    }

    fragment MoneyFragment on MoneyV2 {
        currencyCode
        amount
    }
    fragment ImageFragment on Image {
        id
        url
        altText
        width
        height
    }
`;